/**
 * R6: Orphan auto-link [REVIEW QUEUE, confidence 0.3-1.0]
 *
 * Dla każdego noda z incoming_count=0 AND node_role != 'pillar':
 *   candidates = nody w TYM SAMYM seedzie (oprócz samego orphana)
 *   best_parent = argmax(jaccard(orphan.tokens, candidate.tokens))
 *   if (best.j >= 0.3): propose INSERT thematic_node_relations (best_parent → orphan, type='sibling', weight=5)
 *
 * NIE auto-apply. User akceptuje w UI.
 */

import type {
  RepairRuleInput,
  RepairRuleResult,
  RelationProposal,
} from "@/types/mapRepair";
import { nodeTokens, jaccardSimilarity } from "./_shared";

const MIN_JACCARD = 0.3;

export function runR6(input: RepairRuleInput): RepairRuleResult {
  const proposals: RelationProposal[] = [];

  for (const orphan of input.nodes) {
    const inc = input.incomingByNodeId.get(orphan.id) ?? 0;
    if (inc > 0) continue;
    if (orphan.node_role === "pillar") continue;

    const candidates = input.nodes.filter(
      (c) => c.seed_id === orphan.seed_id && c.id !== orphan.id,
    );
    if (candidates.length === 0) continue;

    const orphanT = nodeTokens(orphan);

    let bestParent = candidates[0];
    let bestJ = 0;
    for (const c of candidates) {
      const j = jaccardSimilarity(orphanT, nodeTokens(c));
      if (j > bestJ) {
        bestJ = j;
        bestParent = c;
      }
    }

    if (bestJ < MIN_JACCARD) continue;

    proposals.push({
      from_node_id: bestParent.id,
      from_node_slug: bestParent.slug,
      to_node_id: orphan.id,
      to_node_slug: orphan.slug,
      relation_type: "sibling",
      weight: 5,
      confidence: Math.round(bestJ * 1000) / 1000,
    });
  }

  // Sort by confidence desc
  proposals.sort((a, b) => b.confidence - a.confidence);

  return {
    rule: "R6",
    operations: [],
    proposals,
    flags: [],
    skipped: [],
  };
}
